import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login.vue";
import Layout from "../components/Layout.vue";
import PageNotFound from "../components/PageNotFound.vue";
import Overview from "../components/Overview.vue";
import Inventory from "../components/inventory/Inventory.vue";
// import Sales from '../components/sales/Sales.vue'
// import Finances from '../components/finances/Finances.vue'
import Customers from '../components/customers/Customers.vue'
import AddCustomer from '../components/customers/AddCustomer.vue';
// import Settings from '../components/settings/Settings.vue'
import Help from "../components/Help.vue";
// import TalkToHuman from '../components/TalkToHuman.vue'
import RequestInventory from "../components/orders/RequestInventory.vue";
import CustomerDetails from '../components/customers/CustomerDetails.vue';
// import PurchasedOrderDetails from '../components/sales/PurchasedOrderDetails.vue'
// import AddStock from '../components/inventory/AddStock.vue'
import EntryLayout from "../components/onboarding/EntryLayout.vue";
import Welcome from "../components/onboarding/Welcome.vue";
import Steps from "../components/onboarding/Steps.vue";
import BusinessInfo from "../components/onboarding/BusinessInfo.vue";
import CompanyInfo from "../components/onboarding/CompanyInfo.vue";
import StoreInfo from "../components/onboarding/StoreInfo.vue";
import ProductInfo from "../components/onboarding/ProductInfo.vue";
import Users from "../components/users/User.vue";
import PreOrdersDetails from "../components/preorder/PreOrdersDetails.vue";
import AddPreProduct from "../components/preorder/AddPreProduct.vue";

import LandingPage from "../components/LandingPage.vue";
// import SetAccount from '../components/onboarding/SetAccount.vue'
import SetupShop from "../components/onboarding/setup-shop/SetupShop.vue";
import Signup from "../components/Signup.vue";
import AccountVerification from "../components/AccountVerification.vue";
import PreviewReceipt from "../components/preorder/PreviewReceipt.vue";
import WaybilPurchasedReceipt from "../components/preorder/WaybilPurchasedReceipt.vue";
import PreviewWaybill from "../components/preorder/PreviewWaybill.vue";
import Finances from "../components/finances/Finances.vue";
import QuickActionReceipt from "../components/preorder/QuickActionReceipt.vue";
import QuickActionReceiptPreView from "../components/preorder/QuickActionReceiptPreView.vue";
import StockAdjustment from '../components/reports/StockAdjustment.vue'
import Supplier from '../components/suppliers/Suppliers.vue'
import Manufacturers from '../components/manufacturers/Manufacturers.vue'
import InventoryTransfer from '../components/reports/InventoryTransfer.vue'
// external router files
import WarehouseRoutes from './warehouseRoutes'
import PipelineRoutes from './PipelineRoutes'
import AccountRoutes from './Account'
import ReportsRoutes from "./ReportsRoutes";
import BackOrderRoutes from './BackOrderRoutes'
import ProductRoutes from "./ProductRoutes";
import LocationRoutes from "./LocationRoutes"
import PurchaseOrderRoutes from './PurchaseOrders'
import ShipmentsRoutes from './ShipmentsRoutes';
import BatchManagementRoutes from './BatchManagementRoutes';
import VaccineTemplateRoutes from './VaccineTemplates';
import BreedsRoutes from './Breeds';
import SubCustomersDetails from '../components/customers/SubCustomersDetails.vue'
import PoultryDetails from '../components/customers/PoultryDetails.vue'
import GeographyRoutes from './GeographyRoutes'




import store from "../store";
import SalesOrders from "./SalesOrders";
Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			//Route not avalaible

			path: '*',
			component: PageNotFound,
		},
		{
			path: '/',
			component: Layout,
			redirect: '/overview',
			meta: {
				requiresAuth: true,
			},
			children: [
				// overview

				{
					path: '/overview',
					name: 'overview',
					component: Overview,
				},
				{
					path: '/finances',
					name: 'finances',
					component: Finances,
				},

				// Customers
				{
					path: '/customers',
					name: 'customers',
					component: Customers,
				},
				{
					path: '/add-customer',
					name: 'add-customer',
					component: AddCustomer,
				},

				// Customers Details
				{
					path: '/customers-details',
					name: 'customers-details',
					component: CustomerDetails,
				},

				{
					path: '/sub-customer-details/:id?',
					name: 'sub-customer-details',
					component: SubCustomersDetails,
				},

				{
					path: '/poultry-details',
					name: 'poultry-details',
					component: PoultryDetails,
				},

				// Stock Adjustment

				{
					path: '/stock-adjustment',
					name: 'stock-adjustment',
					component: StockAdjustment,
				},

				// InventoryTransfer

				{
					path: '/inventory-transfer',
					name: 'inventory-transfer',
					component: InventoryTransfer,
				},

				// inventory

				{
					path: '/inventory',
					name: 'inventory',
					component: Inventory,
				},

				// Products Routes
				...ProductRoutes,

				//all report routes
				...ReportsRoutes,

				//Back Orders routes
				...BackOrderRoutes,

				...BatchManagementRoutes,

				// Sales Orders and preOrders
				...SalesOrders,

				// location routes
				...LocationRoutes,

				...GeographyRoutes,

				// warehouse routes
				...WarehouseRoutes,

				...PipelineRoutes,

				...AccountRoutes,

				// Purchase Order Routes
				...PurchaseOrderRoutes,

				// Shipments Routes
				...ShipmentsRoutes,

				//Vaccine Templates Routes
				...VaccineTemplateRoutes,

				...BreedsRoutes,

				//Request for Inventory

				{
					path: '/request-product',
					name: '',
					component: RequestInventory,
				},
				//Replenish Products
				{
					path: '/replenish',
					name: 'replenish',
					component: () => import('@/components/orders/ReplenishProducts'),
				},

				//Supplier
				{
					path: '/suppliers',
					name: 'suppliers',
					component: Supplier,
				},

				// Manufacturers
				{
					path: 'manufacturers',
					name: 'manufacturers',
					component: Manufacturers,
				},

				//View Campaigns
				{
					path: '/view-campaigns',
					name: 'view-campaigns',
					component: PreOrdersDetails,
				},

				// Low Stock
				{
					path: '/low-stock',
					name: 'low-stock',
					component: QuickActionReceipt,
				},

				// Out of Stock
				{
					path: '/out-of-stock',
					name: 'out-of-stock',
					component: QuickActionReceipt,
				},

				//Purchase Receipt
				{
					path: '/waybill-receipt',
					name: 'waybill-receipt',
					component: WaybilPurchasedReceipt,
				},
				//Purchase Receipt
				{
					path: '/preview-receipt',
					name: 'preview-receipt',
					component: PreviewReceipt,
				},
				//QuickAction Receipt PreView
				{
					path: '/quick-action-preview-receipt',
					name: 'quick-action-preview-receipt',
					component: QuickActionReceiptPreView,
				},
				{
					path: '/preview-waybill-receipt',
					name: 'preview-waybill-receipt',
					component: PreviewWaybill,
				},
				//Add New Product
				{
					path: '/new-pre-product',
					name: 'new-pre-product',
					component: AddPreProduct,
				},
				//Users
				{
					path: '/users',
					name: 'users',
					component: Users,
				},
				// Help

				{
					path: '/help',
					name: 'help',
					component: Help,
				},
			],
		},

		{
			// Entry (Onboarding)

			path: '/entry',
			component: EntryLayout,
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: '/entry',
					name: 'entry',
					component: Welcome,
				},
				{
					path: '/steps',
					component: Steps,
					children: [
						{
							path: '/steps',
							name: 'steps',
							component: BusinessInfo,
						},
						{
							path: '/company-info',
							name: 'company-info',
							component: CompanyInfo,
						},
						{
							path: '/store-info',
							name: 'store-info',
							component: StoreInfo,
						},
						{
							path: '/product-info',
							name: 'product-info',
							component: ProductInfo,
						},
					],
				},
			],
		},

		{
			// login route
			path: '/login',
			component: Login,
		},

		{
			// login route
			path: '/signup',
			component: Signup,
		},

		{
			// Landing Page route
			path: '/welcome',
			component: LandingPage,
			// meta: {
			//     requiresAuth: true
			// },
		},

		{
			// Landing Page route
			path: '/setup-shop',
			component: SetupShop,
		},

		{
			// Account Verification Page route
			path: '/auth',
			component: AccountVerification,
		},
	],
});

//Check if user isLoggedIn already
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // console.log(" isLoggedIn |", store.getters.isLoggedIn )
    // console.log(" IsAgentProfileAvailable |", store.getters.IsAgentProfileAvailable )
    // console.log(" to |",  )
    // console.log("role check | ", store.getters.IsAgentProfileAvailable.roleIds.some(role => role === process.env.VUE_APP_SUPER_ADMIN || role === process.env.VUE_APP_CLIENT))

    if (
      store.getters.isLoggedIn &&
      store.getters?.IsAgentProfileAvailable?.roleIds.some(
        (role) =>
          role === process.env.VUE_APP_SUPER_ADMIN ||
          role === process.env.VUE_APP_CLIENT
      ) &&
      store.getters?.IsAgentProfileAvailable?.isActive
    ) {
      // console.log(" overview route" )
      next();
      return;
    }
    next("/welcome");
  } else {
    next();
  }
});

export default router;
